// Use this to spread traffic to r1, r2, r3 and r4 endpoints.
let count: number = 1;

export default function getCDNIconUrl(icon: string): string {
    return `https://r${(count++ % 4) + 1}.res.outlook.com/owa/prem/images/${icon}.png`;
}
